import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { AcquireLockUseCase } from './AcquireLock';
import { RefreshLockUseCase } from './RefreshLock';
import { DeleteLockUseCase } from './DeleteLock';

export const initializeStreamHarnessUseCases = (container: Container) => {
    container.register(DI.USECASES.IAcquireLockUseCase, {
        useClass: AcquireLockUseCase,
    });
    container.register(DI.USECASES.IRefreshLockUseCase, {
        useClass: RefreshLockUseCase,
    });
    container.register(DI.USECASES.IDeleteLockUseCase, {
        useClass: DeleteLockUseCase,
    });
};
